import React, { useContext } from "react";
import { Link } from "react-router-dom";

import { GlobalContext } from "../../../app/providers/GlobalState";

const MenuDisciplina = ({ inicioUrl, menuOpcaoAtivo, acessos, labelDisciplinas }) => {
    const context = useContext(GlobalContext);

    return (
        <div className="menu-detalhe-curso menu-detalhe-curso-v2">
            <div className="container">
                {(!context.chave_entidade && context.role === "UTILIZADOR") || context.role !== "UTILIZADOR" ? (
                    <ul>
                        {acessos?.includes(16) && (
                            <li>
                                <Link
                                    to={`${inicioUrl}/visao-geral-disciplina`}
                                    className={menuOpcaoAtivo === "visao-geral-disciplina" ? "ativo" : ""}
                                >
                                    Visão Geral
                                </Link>
                            </li>
                        )}
                        {acessos?.includes(17) && (
                            <li>
                                <Link
                                    to={`${inicioUrl}/horario-disciplina`}
                                    className={
                                        menuOpcaoAtivo === "horario-disciplina" ||
                                        menuOpcaoAtivo === "horario-detalhe" ||
                                        menuOpcaoAtivo === "diario-folha-conteudos" ||
                                        menuOpcaoAtivo === "diario-folha-frequencia" ||
                                        menuOpcaoAtivo === "diario-folha-observacoes" ||
                                        menuOpcaoAtivo === "diario-folha-pareceres"
                                            ? "ativo"
                                            : ""
                                    }
                                >
                                    Diário
                                </Link>
                            </li>
                        )}
                        {acessos?.includes(18) && (
                            <li>
                                <Link to={`${inicioUrl}/modulos`} className={menuOpcaoAtivo === "modulos" ? "ativo" : ""}>
                                    Conteúdos
                                </Link>
                            </li>
                        )}
                        {acessos?.includes(19) && (
                            <li>
                                <Link to={`${inicioUrl}/ficheiros`} className={menuOpcaoAtivo === "ficheiros" ? "ativo" : ""}>
                                    Drive
                                </Link>
                            </li>
                        )}
                        {acessos?.includes(20) && localStorage.getItem("entidade_id") !== "33" && (
                            <li>
                                <Link
                                    to={`${inicioUrl}/forum`}
                                    className={`${
                                        menuOpcaoAtivo === "forum" ||
                                        menuOpcaoAtivo === "nova-pergunta" ||
                                        menuOpcaoAtivo === "forum-detalhe" ||
                                        menuOpcaoAtivo === "mensagens" ||
                                        menuOpcaoAtivo === "mensagens-nova" ||
                                        menuOpcaoAtivo === "mensagens-detalhe"
                                            ? "ativo"
                                            : ""
                                    } ant-dropdown-link"`}
                                >
                                    Fórum
                                </Link>
                            </li>
                        )}
                        {acessos?.includes(21) && (
                            <li>
                                <Link
                                    to={`${inicioUrl}/aproveitamento`}
                                    className={menuOpcaoAtivo === "aproveitamento" ? "ativo" : ""}
                                    onClick={() => localStorage.removeItem("vista")}
                                >
                                    Avaliações
                                </Link>
                            </li>
                        )}
                    </ul>
                ) : (
                    <ul>
                        <li>
                            <Link
                                to={`${inicioUrl}/visao-geral-disciplina`}
                                className={menuOpcaoAtivo === "visao-geral-disciplina" ? "ativo" : ""}
                            >
                                {labelDisciplinas}
                            </Link>
                        </li>
                        <li>
                            <Link to={`${inicioUrl}/modulos`} className={menuOpcaoAtivo === "modulos" ? "ativo" : ""}>
                                Atividades
                            </Link>
                        </li>
                    </ul>
                )}
            </div>
        </div>
    );
};

export default MenuDisciplina;
